/**
 * Web entry point — parallel to index.js (the native entry), never used by
 * Metro/iOS/Android. Deliberately does NOT import index.js's
 * @react-native-firebase/messaging background-handler bootstrap (native
 * push has no place here; see src/hooks/usePushNotifications.web.ts).
 *
 * @format
 */

// Web-font-face setup for the icon families this app actually uses
// (react-native-vector-icons ships native .ttf font assets only).
import './web/icons.css';

import { AppRegistry } from 'react-native';
import App from './App';
import { name as appName } from './app.json';

AppRegistry.registerComponent(appName, () => App);

AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});
